// this service is used to get the current mode of the app (ios or md)

import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})

export class ModeService {
  private isIos: boolean;

  constructor(private platform: Platform) {
    this.isIos = this.platform.is('ios');
  }

  isIosMode() {
    return this.isIos;
  }
}



